var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "note_add_FILL0_wght400_GRAD0_opsz48",
    d: "M14.525,18.535h1.35v-2.9H18.8v-1.35H15.875V11.357h-1.35v2.925H11.6v1.35h2.925ZM9.35,22A1.384,1.384,0,0,1,8,20.65V5.35A1.384,1.384,0,0,1,9.35,4h8.122L22.4,8.927V20.65A1.384,1.384,0,0,1,21.05,22ZM16.8,9.535V5.35H9.35v15.3h11.7V9.535ZM9.35,5.35v0Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdd);
export default __webpack_public_path__ + "static/media/note_add.edb45ec4423646d6bc4304f219ec2d87.svg";
export { ForwardRef as ReactComponent };